import Chip from '../common/components/Chip/v2/Chip';
import React from 'react';

export const affiliatePlansHeaders = (extras) => {
    return [
        {
            id: 'STATUS',
            title: 'Estado',
            att: 'status',
            flex: 1,
            sortable: false,
            renderCell: (params) => <Chip text={params.row.status}
                                          status={params.row.status === 'Activo' ? 'success' : 'error'}/>,
        },
        {id: 'CREDENCIAL', title: 'Credencial', att: 'affiliateNumber', sortable: false},
        {id: 'PLAN', title: 'Plan', att: 'name', sortable: false},
        ...extras.map((extra) => ({
            id: extra.id,
            title: extra.title,
            att: extra.att,
            flex: extra.flex,
            sortable: extra.sortable,
        })),
    ];
};

export const downDateHeader = {
    id: 'FECHA DE BAJA',
    title: 'Fecha de baja',
    att: 'downDate',
    flex: 1,
    sortable: false,
};

export const createdDateHeader = {
    id: 'FECHA DE ALTA',
    title: 'Fecha de alta',
    att: 'createdDate',
    flex: 1,
    sortable: false,
};
